export default __webpack_public_path__ + "static/transfer-brand-assets-c4830baf6cc46ed065d6ba56f6409458.svg";